import { ConversationPreset, NotificationType } from "@markit/common.types";
import { useCallback, useMemo, useState } from "react";
import { DropdownMenu, DropdownMenuItem } from "../DropdownMenu";
import ThreeDotsButton from "../Buttons/ThreeDotsButton";
import { API } from "../../API";
import { useDispatch, useSelector } from "react-redux";
import { getAccountState } from "../../redux/slices/accountSlice";
import { showNotificationBanner } from "../../utils/notificationUtils";
import ConfirmDeleteModal from "../Containers/ConfirmPopups/ConfirmDeleteModal";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import { conversationActions } from "../../redux/slices/conversationSlice";

type ConversationPresetItemProps = {
  item: ConversationPreset;
  editPreset: () => void;
};

export const ConversationPresetItem = (props: ConversationPresetItemProps) => {
  const { item, editPreset } = props;
  const { uid } = useSelector(getAccountState).account.accountData;

  const dispatch = useDispatch();
  const [confirmDelete, setConfirmDelete] = useState(false);

  const deletePreset = useCallback(async () => {
    await API.conversation.deleteConversationPreset({
      userId: uid,
      conversationPresetId: item.id,
    });
    dispatch(conversationActions.removeConversationPreset(item.id));
    showNotificationBanner(
      dispatch,
      "Preset Deleted",
      NotificationType.NEGATIVE
    );
  }, [uid, item.id, dispatch]);

  const dropdownItems: DropdownMenuItem[] = useMemo(
    () => [
      {
        title: "Edit",
        icon: "ion:create",
        key: "edit_preset",
        onPress: editPreset,
      },
      {
        title: "Delete",
        icon: "ion:trash",
        key: "delete_preset",
        onPress: () => setConfirmDelete(true),
        isDestructive: true,
      },
    ],
    [editPreset]
  );

  return (
    <>
      <div className="AlignedRowSpaced" style={{ flex: 1 }}>
        <div className="ColumnNormal" style={{ gap: 7 }}>
          <span className="bodyMedium" style={{ whiteSpace: "pre-line" }}>
            {item.preset}
          </span>
          <span className="smallBodySubtext">Text Preset</span>
        </div>
        <DropdownMenu
          dropdownItems={dropdownItems}
          trigger={["click"]}
          placement="bottomLeft"
          altWidth={150}
        >
          <ThreeDotsButton onPress={() => {}} />
        </DropdownMenu>
      </div>
      {confirmDelete ? (
        <ConfirmDeleteModal
          heading="Delete Preset?"
          subtext="Are you sure you want to delete this preset? This cannot be undone."
          deleteButtonText="Delete"
          icon={
            <Icon icon="ion:trash" height={35} style={{ color: Colors.RED3 }} />
          }
          hideModal={!confirmDelete}
          setIsVisible={setConfirmDelete}
          deleteOnPress={deletePreset}
        />
      ) : null}
    </>
  );
};
